(<template>
  <div id="map-container">
    <div v-if="isEditable" id="floating-panel">
      <gmap-autocomplete @place_changed="usePlace" id="search"></gmap-autocomplete>
    </div>
    <gmap-map :center="center" :zoom="13" id="map" @click="setPosition">
      <gmap-marker v-if="pos.lat !== null && pos.lng !== null"
                   :position="pos"
                   :clickable="true"
                   :draggable="isEditable"
                   @click="center=pos"
                   @drag="setPosition"></gmap-marker>
    </gmap-map>
    <el-input v-if="pos.lat !== null && pos.lng !== null && isEditable"
              :value="posText"
              :readonly="true"></el-input>
  </div>
</template>)

(<script>
export default {
  name: 'map-view',
  props: ['position', 'is-editable'],
  data () {
    var center = process.env.MAP_CENTER
    if (this.position.lat !== null && this.position.lng !== null) {
      center = this.position
    }
    return {
      center,
      pos: this.position
    }
  },
  computed: {
    posText () {
      return `${this.pos.lat}, ${this.pos.lng}`
    }
  },
  methods: {
    usePlace (place) {
      if (this.isEditable && place) {
        this.pos = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        }
        this.$emit('set-position', this.pos)
      }
    },
    setPosition (position) {
      if (this.isEditable) {
        this.pos = {
          lat: position.latLng.lat(),
          lng: position.latLng.lng()
        }
        this.$emit('set-position', this.pos)
      }
    }
  }
}
</script>)

(<style>
#map {
  width: 100%;
  padding-top: 56.25%;
  position: relative;
}

#search {
  width: 80%;
}

#floating-panel {
  position: absolute;
  top: 10px;
  z-index: 1;
  justify-content: center;
  background-color: white;
  padding: 5px;
  border: 1px solid #999;
  border-radius: 5px;
  width: 33%;
  left: 33%;
}

#map-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 5px;
}
</style>)



// WEBPACK FOOTER //
// src/components/Map-View.vue